import { IChatConfig } from "@interfaces/chat/chatConfig";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IChatConfig = {
    activeVoiceCall: false,
    callDuration: "",
    defaultChatLogin: "",
    typePerson: ""
}

export const chatConfigSlice = createSlice({
    name: "chatConfig",
    initialState: initialState,
    reducers: {
        setChatConfig: (state, action: PayloadAction<IChatConfig>) => {
            // state.profileChatSettingsId = action.payload.profileChatSettingsId;
            // state.username = action.payload.username;
            state.roleCode = action.payload.roleCode;
            state.activeVoiceCall = action.payload.activeVoiceCall;
            state.typePerson = action.payload.typePerson ;
            state.defaultChatLogin = action.payload.defaultChatLogin;
        },
        cleanChatConfig: (state) => {
            state = initialState;
        },
    },
});

export const { setChatConfig, cleanChatConfig } = chatConfigSlice.actions;
export default chatConfigSlice.reducer;
